"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidUrl = exports.isValidEmail = void 0;
exports.useForm = useForm;
var email_validator_1 = require("email-validator");
var react_1 = require("react");
function useForm(_a) {
    var _this = this;
    var onSubmit = _a.onSubmit, onFormChange = _a.onFormChange, initialValues = _a.initialValues, validateFields = _a.validateFields;
    var mounted = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        mounted.current = true;
        return function () {
            mounted.current = false;
        };
    }, []);
    var validationRules = (0, react_1.useRef)(validateFields);
    validationRules.current = validateFields;
    var _b = (0, react_1.useState)(Object.assign({}, initialValues)), form = _b[0], setForm = _b[1];
    var _c = (0, react_1.useState)({}), errors = _c[0], setErrors = _c[1];
    var _d = (0, react_1.useState)(false), isSubmittingForm = _d[0], setIsSubmittingForm = _d[1];
    var handleFormSubmit = (0, react_1.useCallback)(function (e) { return __awaiter(_this, void 0, void 0, function () {
        var _a, validatedErrors, isFormValid;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    e.preventDefault();
                    _a = validateForm(form, validationRules.current), validatedErrors = _a.errors, isFormValid = _a.isFormValid;
                    if (!isFormValid) return [3 /*break*/, 4];
                    setIsSubmittingForm(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, Promise.resolve(onSubmit(form))];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    if (mounted.current) {
                        setIsSubmittingForm(false);
                    }
                    return [7 /*endfinally*/];
                case 4:
                    if (mounted.current) {
                        setErrors(validatedErrors);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [validateForm, form, onSubmit, setIsSubmittingForm, setErrors]);
    var updateForm = (0, react_1.useCallback)(function (name, value) {
        setForm(function (prevForm) {
            var _a;
            var updatedForm = Object.assign({}, prevForm, (_a = {}, _a[name] = value, _a));
            onFormChange === null || onFormChange === void 0 ? void 0 : onFormChange(updatedForm);
            return updatedForm;
        });
        setErrors(function (oldErrors) {
            var _a;
            return Object.assign({}, oldErrors, (_a = {}, _a[name] = undefined, _a));
        });
    }, [onFormChange, setForm, setErrors]);
    var reset = (0, react_1.useCallback)(function (form) {
        setForm(form);
        if (mounted.current) {
            setErrors(validateForm(form, validationRules.current).errors);
        }
    }, []);
    var handleChange = (0, react_1.useCallback)(function (e) {
        if (isValueEvent(e)) {
            return updateForm(e.name, e.value);
        }
        var event = isCommonUIEvent(e) ? e.event : e;
        var currentTarget = event.currentTarget;
        if (currentTarget instanceof HTMLInputElement && currentTarget.type === 'checkbox') {
            return updateForm(currentTarget.name, currentTarget.checked);
        }
        if (currentTarget instanceof HTMLInputElement && currentTarget.type === 'number') {
            var value = currentTarget.value;
            var valueNr = Number(value);
            if (isNaN(valueNr)) {
                return;
            }
            return updateForm(currentTarget.name, valueNr);
        }
        return updateForm(currentTarget.name, currentTarget.value);
    }, [updateForm]);
    return (0, react_1.useMemo)(function () { return ({
        form: form,
        errors: errors,
        onChange: handleChange,
        onSubmit: handleFormSubmit,
        reset: reset,
        isSubmittingForm: isSubmittingForm,
    }); }, [form, errors, handleChange, handleFormSubmit, isSubmittingForm]);
}
// Typeguard used to handle events from custom components
function isValueEvent(event) {
    if (event.name === undefined || event.value === undefined) {
        return false;
    }
    var value = event.value;
    return typeof value === 'string' || typeof value === 'boolean' || !Number.isNaN(value) || Array.isArray(value);
}
function isCommonUIEvent(event) {
    return event.event !== undefined;
}
var validateForm = function (form, validationFields) {
    if (validationFields === undefined) {
        return {
            isFormValid: true,
            errors: {},
        };
    }
    var formFieldNames = Object.keys(form);
    var errors = formFieldNames.reduce(function (memo, formFieldName) {
        var value = form[formFieldName];
        var validationType = validationFields[formFieldName];
        if (validationType === undefined) {
            return memo;
        }
        var nonEmptyValidation = validationType['exist'];
        var emailValidation = validationType['email'];
        var urlValidation = validationType['url'];
        var customValidation = validationType['custom'];
        if (nonEmptyValidation !== undefined) {
            if (value === '' || value === null || value === undefined) {
                memo[formFieldName] = nonEmptyValidation;
                return memo;
            }
        }
        if (customValidation !== undefined && !customValidation.condition(value)) {
            memo[formFieldName] = customValidation.error;
            return memo;
        }
        if (emailValidation !== undefined && !(0, exports.isValidEmail)(value)) {
            memo[formFieldName] = emailValidation;
            return memo;
        }
        if (urlValidation !== undefined && !(0, exports.isValidUrl)(value)) {
            memo[formFieldName] = urlValidation;
            return memo;
        }
        return memo;
    }, {});
    return {
        isFormValid: Object.keys(errors).length === 0,
        errors: errors,
    };
};
var isValidEmail = function (email) {
    if (typeof email !== 'string') {
        return false;
    }
    return (0, email_validator_1.validate)(email);
};
exports.isValidEmail = isValidEmail;
var isValidUrl = function (url) {
    if (typeof url !== 'string') {
        return false;
    }
    var regex = new RegExp(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)/g);
    return regex.test(url);
};
exports.isValidUrl = isValidUrl;
//# sourceMappingURL=use_form.js.map